var map = {
	"./signature-abandon-en.png": 35027,
	"./signature-abandon-es.png": 93654,
	"./signature-abandon-history-en.png": 30166,
	"./signature-abandon-history-es.png": 82483,
	"./signature-delete-en.png": 31395,
	"./signature-delete-es.png": 66470,
	"./signature-detail-en.png": 87237,
	"./signature-detail-es.png": 26784,
	"./signature-form-en.png": 46798,
	"./signature-form-es.png": 48411,
	"./signature-forward-form-en.png": 93082,
	"./signature-forward-form-es.png": 84303,
	"./signature-forward-history-en.png": 42390,
	"./signature-forward-history-es.png": 41235,
	"./signature-forward-popup-en.png": 88524,
	"./signature-forward-popup-es.png": 85913,
	"./signature-incidence-dashboard-en.png": 69293,
	"./signature-incidence-dashboard-es.png": 31704,
	"./signature-incidence-popup-en.png": 96567,
	"./signature-incidence-popup-es.png": 37778,
	"./signature-joint-detail-en.png": 22190,
	"./signature-joint-detail-es.png": 23803,
	"./signature-joint-en.png": 12202,
	"./signature-joint-es.png": 99679,
	"./signature-list-en.png": 696,
	"./signature-list-es.png": 85261,
	"./signature-menu-en.png": 69239,
	"./signature-menu-es.png": 26802,
	"./signature-reject-form-en.png": 67210,
	"./signature-reject-form-es.png": 26399,
	"./signature-reject-popup-en.png": 38268,
	"./signature-reject-popup-es.png": 3177,
	"./signature-sign-PIN-en.png": 8267,
	"./signature-sign-PIN-es.png": 53470,
	"./signature-sign-detail-en.png": 87403,
	"./signature-sign-detail-es.png": 62334,
	"./signature-sign-document-en.png": 32299,
	"./signature-sign-document-es.png": 77502,
	"./signature-upload-files1-en.png": 36492,
	"./signature-upload-files1-es.png": 33881,
	"./signature-upload-files2-en.png": 31877,
	"./signature-upload-files2-es.png": 24448,
	"./signature-upload1-en.png": 82370,
	"./signature-upload1-es.png": 70567,
	"./signature-upload2-en.png": 32535,
	"./signature-upload2-es.png": 64978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99130;